export default __webpack_public_path__ + "static/media/The B Major.827f727f.png";